'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [{
  component: function () {
    function Dots() {
      (0, _classCallCheck3.default)(this, Dots);
    }

    (0, _createClass3.default)(Dots, [{
      key: 'render',
      value: function render() {
        var _this = this;

        var styles = require('./CarouselDecorator.scss');
        var dots = [];

        var _loop = function _loop(i) {
          var j = i + 1;
          dots.push(_react2.default.createElement(
            'li',
            { key: 'dotkey' + i, className: (0, _classnames2.default)((0, _defineProperty3.default)({}, styles.isActive, _this.props.currentSlide === i)) },
            _react2.default.createElement(
              'span',
              { onClick: function onClick() {
                  return _this.props.goToSlide(i);
                }, className: styles.number },
              '0',
              j
            ),
            _react2.default.createElement('span', { className: styles.dash })
          ));
        };

        for (var i = 0; i < this.props.slideCount; i++) {
          _loop(i);
        }

        return _react2.default.createElement(
          'ul',
          { className: styles.dots },
          dots
        );
      }
    }]);
    return Dots;
  }()
}];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ImageSlider/CarouselDecorator/CarouselDecorator.js
 ** module id = 1091
 ** module chunks = 0
 **/